import { render, staticRenderFns } from "./edit-btn-item.vue?vue&type=template&id=5cbc7d1d&scoped=true&"
import script from "./edit-btn-item.vue?vue&type=script&lang=js&"
export * from "./edit-btn-item.vue?vue&type=script&lang=js&"
import style0 from "./edit-btn-item.vue?vue&type=style&index=0&id=5cbc7d1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc7d1d",
  null
  
)

export default component.exports